import { Navigate } from 'react-router';

import { OidcSecure } from '@axa-fr/react-oidc';
import { COOKIE_NAMES, getCookie, routes } from '@fly/shared';

export function FlyOidcSecure({ children }: { children: React.ReactNode }) {
  const noTenantId = getCookie(COOKIE_NAMES.NO_TENANT_ID);

  if (noTenantId === 'true') {
    return <Navigate to={routes.SIGN_UP.TEAM_REGISTER} />;
  }

  return <OidcSecure>{children}</OidcSecure>;
}
